import { atom } from "recoil";
import { ocPersistAtom } from "./persist-atom";

export const ocRefreshTokenState = atom({
  key: "ocRefreshTokenState",
  default: false,
  effects_UNSTABLE: [ocPersistAtom],
});
